// (function () {
//     'use strict';

//     angular.module("imApp").factory("specialCustProdCalcService", ['$ihttp', function ($ihttp) {
//         let service = {
//             listProducts: function (parms) {
//                 return $ihttp.post({
//                     method: 296,
//                     parameters: parms || {}
//                 });
//             },
//             getCalculation: function (parms) {
//                 return $ihttp.post({
//                     method: 297,
//                     parameters: parms || {}
//                 });
//             },
//             listPrices: function (parms) {
//                 return $ihttp.post({
//                     method: 298,
//                     parameters: parms || {}
//                 });
//             }
//         }

//         return service;
//     }]);
// })();
